import React, { useState } from 'react'
import dayjs from 'dayjs'
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Box,
  Divider,
} from '@chakra-ui/core'
import Options from './Options'
import ChangeProject from './ChangeProject'
import ChangeDates from './ChangeDates'
import CopyProject from './CopyProject'
import ChangeProjectResource from './ChangeProjectResource'
import AddResorce from './AddResorce'
import AddPerson from './AddPerson'

const Actions = (props) => {
  const [open, setOpen] = useState(false)
  const [view, setView] = useState(false)
  const { data, type } = props

  return (
    <div className={`editButton ${props.type || ''}`}>
      <Popover
        placement="right-start"
        closeOnBlur={true}
        closeOnEsc={true}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        isOpen={open}
      >
        <PopoverTrigger>
          <button
            style={{
              border: 'none',
              cursor: 'pointer',
              padding: '2px',
              borderRadius: '4px',
            }}
            aria-label="Actions"
          >
            <i className={`icon-list icons`} />
          </button>
        </PopoverTrigger>
        {open && (
          <Portal>
            <PopoverContent
              zIndex={9999}
              maxWidth="160px"
              marginTop={'-.5em'}
              border={'none'}
              background={
                'linear-gradient(150deg,rgba(19, 7, 7, 1) 0%, rgba(19, 7, 7, 0.5) 50%, rgba(255, 255, 255, 0) 80%)'
              }
            >
              <PopoverArrow mt={'.5em'} background={'rgba(54, 25, 25, 1)'} />
              <PopoverBody>
                <Box mb={'.6em'} color={'white'}>
                  {type !== 'project' ? (
                    <>
                      <Box
                        fontWeight={'bold'}
                        fontSize={'.8em'}
                        background={'#fff'}
                        color={'#000'}
                        display={'inline-block'}
                        borderRadius={'4px'}
                        p={'.1em .5em'}
                        mb={'.3em'}
                      >
                        {props.type !== 'resorce'
                          ? `${data?.firstName} ${data?.lastName}`
                          : `${data?.code}`}
                      </Box>
                      <Box fontWeight={'bold'} fontSize={'.6em'} mb={'1em'}>
                        <i
                          className={'icons icon-calendar'}
                          style={{ marginRight: '4px' }}
                        />
                        {`${dayjs(data?.startDate)?.format(
                          'DD/MM/YYYY'
                        )} - ${dayjs(data?.endDate)?.format('DD/MM/YYYY')}`}
                      </Box>
                    </>
                  ) : (
                    <Box
                      fontWeight={'bold'}
                      fontSize={'.8em'}
                      background={'#fff'}
                      color={'#000'}
                      display={'inline-block'}
                      borderRadius={'4px'}
                      p={'.1em .5em'}
                      mb={'.3em'}
                    >
                      {data?.name}
                    </Box>
                  )}
                  <Divider />
                </Box>
                {!view && (
                  <Options {...props} setOpen={setOpen} setView={setView} />
                )}
                {view === 'changeProject' && (
                  <ChangeProject
                    {...props}
                    setOpen={setOpen}
                    setView={setView}
                  />
                )}
                {view === 'changeProjectResource' && (
                  <ChangeProjectResource
                    {...props}
                    setOpen={setOpen}
                    setView={setView}
                  />
                )}
                {view === 'changeDates' && (
                  <ChangeDates {...props} setOpen={setOpen} setView={setView} />
                )}
                {view === 'copyToProject' && (
                  <CopyProject {...props} setOpen={setOpen} setView={setView} />
                )}

                {view === 'associatePerson' && (
                  <AddPerson {...props} setOpen={setOpen} setView={setView} />
                )}

                {view === 'associateMaterial' && (
                  <AddResorce {...props} setOpen={setOpen} setView={setView} />
                )}
              </PopoverBody>
            </PopoverContent>
          </Portal>
        )}
      </Popover>

      {/* <div className="actionsWrap">
        <div className="actions"></div>
      </div> */}
    </div>
  )
}

export default Actions
